import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { Loading, Message, MessageBox } from "element-ui";
let getHeaders = "";
// const baseURL = 'http://localhost:28086/' // 本地环境
// const baseURL = 'http://localhost:28086/' // 线上环境

// 请求计数器
let activeRequests = 0;
let loadingInstance = null;
let logoutConfirming = false;

function forceLogout(msg) {
    if (logoutConfirming) return;
    logoutConfirming = true;
    MessageBox.alert(msg || "登录已失效，请重新登录", "提示", {
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
    })
        .then(() => {
            const accessToken = sessionStorage.getItem("Authorization") || "";
            return store.dispatch("user/resetToken").finally(() => {
                window.location.href =
                    process.env.VUE_APP_KW_AUTH_BASE_URL +
                    "enterpriseAuth/logout?accessToken=" +
                    accessToken +
                    "&systemType=kwjfComClient";
            });
        })
        .finally(() => {
            logoutConfirming = false;
        });
}

// 管理loading状态
const loading = {
    // 显示全局loading
    show() {
        if (!loadingInstance) {
            loadingInstance = Loading.service({
                fullscreen: true,
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }
    },

    // 隐藏loading
    hide() {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
    },

    // 开始新请求
    start() {
        if (activeRequests === 0) {
            this.show();
        }
        activeRequests++;
    },

    // 结束请求
    end() {
        activeRequests--;
        if (activeRequests === 0) {
            this.hide();
        }
    }
};

const service = axios.create({
    // baseURL: baseURL,
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 5000
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        if (getHeaders) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        if (store.getters.token) {
            config.headers["userId"] = getToken();
            config.headers["Authorization"] = getToken();
        } else {
            let url = window.location.href;
            if (url.indexOf("login") < 0) {
                alert("登录超时，请重新登录");
                this.$router.replace("name");
            }
        }
        // 显示loading，除非明确跳过
        if (config.skipLoading !== true) {
            loading.start();
        }
        return config;
    },
    (error) => {
        loading.end();
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // 请求完成，减少计数
        if (response.config.skipLoading !== true) {
            loading.end();
        }
        const res = response.data;
        if (Number(res.code) === 200) {
            return res;
        }
        if (Number(res.code) === 410 && response.config.skipGlobal410 !== true) {
            forceLogout(res.msg);
            return Promise.reject(res);
        }
        if (response.config.skipGlobalErrorTip !== true) {
            Message.error(res.msg || "请求失败");
        }
        return Promise.reject(res);
    },
    (error) => {
        // 错误时也需要减少计数
        if (error.config && error.config.skipLoading !== true) {
            loading.end();
        }
        return Promise.reject(error);
    }
);

// 封装POST请求
export function post(url, data = {}, headers = false) {
    getHeaders = headers ? true : false;
    return service.post(url, data);
}

export default service;
